import './css/style.css';
export default class Animation {
    constructor(opts) {
        this.options = {
            type: 'plane',
            message: '',    // 恭喜 XX 团队的 <span>Honey</span> <br/>成功收款 <span>20000元</span>
            time: 20000
        }
        if(opts){
            Object.assign(this.options,opts);
        };
        let type = this.options.type;
        let content = document.createElement('div');
        let img = document.createElement('div');
        // let content = document.createElement('div');
        content.className = "message-content";
        img.className = "imgIcon";
        this[type] = document.createElement('div');
        this[type].title = "点击关闭";
        this[type].className = ((opts.type !== 'FirstPrice') && (opts.type !== 'SecondPrice') && (opts.type !== 'ThirdPrice')) ? `c-m-modal crm-${type}` : `c-m-modal-center crm-${type}`;
        this[type].appendChild(img);
        this[type].appendChild(content);
        this.create();
    }
    create() {
        let { type, message } = this.options;
        let reg=/(\w*)<(.*)>/g;
        this[`${type}`].querySelector('.message-content').innerHTML ='<div class="messageLeft ' + (((type !== 'FirstPrice') && (type !== 'SecondPrice') && (type !== 'ThirdPrice')) ? 'flex_left"' : 'flex_center"') + '>'+ message.replace(/\<(.*?)\>/g,"<span>$1</span>") + '</div>';
        this[`${type}`].className += ' c-m-modal-move';
        document.body.appendChild(this[`${type}`]);
        this._bindClick();
        this.destroy();
    }
    destroy() {
        setTimeout(()=>{
            this._remove();
        },this.options.time);
    }
    _bindClick() {
        this[`${this.options.type}`].onclick = ()=> this._remove();
    }
    _remove() {
        if(!this[`${this.options.type}`]){
            return;
        }
        document.body.removeChild(this[`${this.options.type}`]);
        this[`${this.options.type}`] = undefined;

    }
}
